export const TransactionBlackList = ['Vipps straksbet.', 'Overførsel', 'Varekjøp', 'Overføring'];
